/** Deploy crossover is a version transition, never an unsupported game rule. */
export function isCompileEngineMismatch(error: unknown): boolean {
    const reason = typeof error === 'string' ? error : error instanceof Error ? error.message : '';
    return /(?:^|:)compile-worker-engine-mismatch(?:$|,)/.test(reason);
}

const retryKey = (engine: string): string => `ft:compile-worker-recovery:${engine}`;
/** A recovery navigation must not reuse bytes cached under the original ?v URL. */
export function compileWorkerRecoveryToken(engine: string): string | null {
    try { return sessionStorage.getItem(retryKey(engine)); } catch { return null; }
}

export function createCompileVersionRecovery(engine: string, hooks: {
    pause(next: string): void;
    banner(): void;
    hasEncounter(): boolean;
    report(next: string): void;
    reload(): void;
}) {
    const seen = new Set<string>();
    return (next = 'unknown-worker'): void => {
        if (seen.has(next)) return;
        seen.add(next);
        hooks.pause(next === engine ? 'compile-worker-engine-mismatch' : next);
        hooks.banner();
        hooks.report(next);
        if (hooks.hasEncounter()) return;
        // If storage is unavailable, leave the reload button usable. Reloading
        // without a durable attempt marker would loop across fresh page realms.
        try {
            const pair = `ft:compile-worker-reload:${[engine, next].sort().join(':')}`;
            if (sessionStorage.getItem(pair)) return;
            sessionStorage.setItem(pair, '1');
            if (sessionStorage.getItem(pair) !== '1') return;
            sessionStorage.setItem(retryKey(engine), next);
        } catch { return; }
        setTimeout(() => { if (!hooks.hasEncounter()) hooks.reload(); }, 2000);
    };
}

declare global {
    interface Window { ftHandleCompileEngineMismatch?: (error: unknown, next?: string) => boolean }
}
